(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneCallResultSearch', PhoneCallResultSearch);

    PhoneCallResultSearch.$inject = ['$resource'];

    function PhoneCallResultSearch($resource) {
        var resourceUrl =  'api/_search/phone-call-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
